import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const objectToFormData = (
  obj: Record<string, any>,
  formData: FormData = new FormData(),
  parentKey: string = ''
): FormData => {
  Object.entries(obj).forEach(([key, value]) => {
    const fieldName = parentKey ? `${parentKey}[${key}]` : key;

    if (value instanceof File || value instanceof Blob) {
      formData.append(fieldName, value);
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        formData.append(`${fieldName}[${index}]`, item);
      });
    } else if (typeof value === 'object' && value !== null) {
      objectToFormData(value, formData, fieldName);
    } else {
      formData.append(fieldName, String(value));
    }
  });

  return formData;
};
